export default "__VITE_ASSET__DlSqps8V__"